var _defs, _polygon, _polygon2, _polygon3, _polygon4, _polygon5, _polygon6, _polygon7, _polygon8, _polygon9, _polygon0, _path, _path2, _path3, _path4, _path5, _path6, _path7, _text;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogotipo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Original",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 141.31 31.82",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-3{fill:#009ade;}.cls-2{fill:#f15a22;}.cls-3{font-size:5.9px;font-family:Butler-Medium, Butler;letter-spacing:0.38em;}.cls-4{letter-spacing:0.36em;}.cls-5{letter-spacing:0.38em;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Logotipo-horizontal") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "6.53 15.67 10.6 10.49 15.42 9.05 15.75 12.96 6.53 15.67"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "4.34 18.49 15.94 15.03 16.69 24 0 24 4.34 18.49"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "31.26 15.67 27.19 10.49 22.37 9.05 22.04 12.96 31.26 15.67"
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "33.45 18.49 21.85 15.03 21.1 24 37.79 24 33.45 18.49"
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "17.4 6.52 18.84 6.08 20.32 6.53 20.32 6.52 25.16 7.96 18.89 0 12.62 7.96 15.75 7.03 17.4 6.52"
  })), _polygon6 || (_polygon6 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "18.84 6.08 18.89 0 12.62 7.96 18.84 6.08"
  })), _polygon7 || (_polygon7 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "18.85 12.05 19.84 12.33 20.17 8.34 18.84 7.98 17.56 8.34 17.9 12.34 18.85 12.05"
  })), _polygon8 || (_polygon8 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "18.84 14.13 18.07 14.37 18.88 24 19.67 14.38 18.84 14.13"
  })), _polygon9 || (_polygon9 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "18.82 12.05 18.85 12.05 18.84 7.98 17.56 8.34 17.9 12.33 18.82 12.05"
  })), _polygon0 || (_polygon0 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "18.81 14.13 18.07 14.36 18.88 24 18.86 14.14 18.81 14.13"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M132.17,57.56v6.64H116.12v-.41c1.34,0,1.72-1.15,1.72-3.32V45.14c0-2-.32-3-1.72-3v-.41h15.64v5.74h-.41c-.38-5.27-5.9-5.33-8.49-5.33h-1.72v10.5h2.07c.86,0,4.24,0,4.4-3.22H128v6.86h-.41c-.16-3.19-3.61-3.22-4.4-3.22h-2.07V63.78h1.47c2.84,0,8.49.16,9.16-6.22Z",
    transform: "translate(-76.17 -40.26)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M151.12,63.87l-3.48.57c-.89.16-.89-.57-.89-.57V62.12a5.69,5.69,0,0,1-4.69,2.36c-4.28,0-6.73-3.38-6.73-7.85,0-4.95,3.22-7.47,7.5-7.47a6.73,6.73,0,0,1,3.92,1.18V43.71c0-1.12-.32-1.53-1.63-1.79v-.41l4.37-.86V61.7c0,1.56.35,1.76,1.63,1.76Zm-4.37-9.67c0-3.1-1.91-4.63-3.86-4.63-2.11,0-4.24,1.5-4.24,6.61s1.63,7.37,4.4,7.37a3.6,3.6,0,0,0,3.7-3.77Z",
    transform: "translate(-76.17 -40.26)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M158.14,64.19h-5.36v-.41c1.21-.35,1.28-.93,1.28-2.55V52.39c0-1.12-.26-1.56-1.6-1.91v-.38l4.37-.93V61.23c0,1.79.16,2.27,1.31,2.55Zm-4.63-19.31a1.59,1.59,0,0,1,1.63-1.63,1.61,1.61,0,0,1,1.63,1.63,1.63,1.63,0,0,1-1.63,1.63A1.61,1.61,0,0,1,153.51,44.89Z",
    transform: "translate(-76.17 -40.26)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M174.08,64.1h-5.36v-.26c1.21-.35,1.24-.93,1.24-2.55V51.84c0-1.12-.32-2.07-1.6-2.07H164V61.39c0,1.76.41,2.27,1.53,2.46v.26h-5.58v-.26c1.21-.26,1.28-.83,1.28-2.46V49.77h-2l-.06-.41h2.11V49c0-6.7,2.62-8.68,7.15-8.68,1.95,0,3.77.89,4.12,2.62a2.47,2.47,0,0,1-.26,1.91,1.72,1.72,0,0,1-2.36.32,1.66,1.66,0,0,1-.29-2.39,1.37,1.37,0,0,1,1.09-.61c.73,0-.13-1.44-2.3-1.44-1.34,0-4.37.29-4.37,7.85v.77h8.77V61.29c0,1.76.16,2.27,1.31,2.55Z",
    transform: "translate(-76.17 -40.26)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M189.59,60.17c-.35,1.6-2,4.21-5.9,4.21-3.57,0-7-2.94-7-7.63a7.54,7.54,0,0,1,7.75-7.69c3.13,0,4.08,1.44,4.37,1.95a1.6,1.6,0,0,1,0,1.56,1.54,1.54,0,0,1-2,.54,1.45,1.45,0,0,1-.54-2,1.28,1.28,0,0,1,.89-.67c.29-.06-.57-1-2.71-1-1.28,0-4.79,1-4.79,6.92,0,4.24,2.39,6,4.66,6.22A5.11,5.11,0,0,0,189.24,60Z",
    transform: "translate(-76.17 -40.26)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M205.38,62.06l.38.16a3,3,0,0,1-2.94,2.17,2.68,2.68,0,0,1-2.71-2.68c-.45,1.53-2.3,2.68-4.53,2.68,0,0-3.64,0-3.64-3.29s2.71-3.89,8.17-5.3V54c0-3.29-1.66-5.14-4.21-4-1.24.61-1.44,1.21-1.24,1.24a1.45,1.45,0,0,1,1,.57,1.48,1.48,0,0,1-.32,2.07,1.41,1.41,0,0,1-2-.29,1.48,1.48,0,0,1-.16-1.56,5.18,5.18,0,0,1,2.49-2.36,6.4,6.4,0,0,1,2.94-.61c3.48,0,4.44,2.58,4.44,6.38v5.42s0,2,1.44,2A1,1,0,0,0,205.38,62.06Zm-10.59-1.63a2.43,2.43,0,0,0,2.52,2.52,3,3,0,0,0,2.81-2V56.22C196.42,57.11,194.79,58.51,194.79,60.43Z",
    transform: "translate(-76.17 -40.26)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M217.06,49.77a1.74,1.74,0,0,1-.22,2.49,1.77,1.77,0,0,1-2.49-.22,1.45,1.45,0,0,1-.35-1.21c.1-.54-2,.22-3,2.36v7.95c0,1.79.16,2.27,1.31,2.55v.41h-5.39v-.41c1.21-.35,1.28-.89,1.28-2.55V52.29c0-1.12-.29-1.56-1.6-1.91V50l4.4-.93v3.35a6,6,0,0,1,4.28-3.25A2.2,2.2,0,0,1,217.06,49.77Z",
    transform: "translate(-76.17 -40.26)"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    className: "cls-3",
    transform: "translate(41.03 30.1)"
  }, "SEGU", /*#__PURE__*/React.createElement("tspan", {
    className: "cls-4",
    x: 24.76,
    y: 0
  }, "R"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-5",
    x: 30.95,
    y: 0
  }, "OS"))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogotipo);
export default __webpack_public_path__ + "static/media/Logotipo.558f5c43dd04fff940e1113dd5b2ce75.svg";
export { ForwardRef as ReactComponent };